/**
 * Company Profile Mappers
 * Transform functions between transport layer (LC_*) and domain models
 */

import type { LC_GetCompanyByIdOut, CompanyProfile } from '../types/companyProfile.types';

/**
 * Maps LC_GetCompanyByIdOut (transport) to CompanyProfile (domain)
 * Normalizes empty strings and null values to empty strings for UI consumption
 */
export function mapCompanyByIdOutToProfile(
  transport: LC_GetCompanyByIdOut,
): CompanyProfile {
  return {
    id: transport.companyId,
    rut: transport.companyRUT || '',
    dv: transport.companyDV || '',
    name: transport.companyName || '',
    fantasyName: transport.companyNameFantasy || '',
    address: transport.companyAddress || '',
    addressNumber: transport.companyAddressNumber || '',
    regionId: transport.companyAddressRegionId,
    communeId: transport.companyAddressCommuneId,
    contactName: transport.namePersonContact ?? '',
    contactEmail: transport.emailPersonContact ?? '',
    contactPhone: transport.telephonePersonContact ?? '',
    terminateExpiredContracts: transport.terminateEmployeesWithExpiredContract,
    syncWithRex: transport.synchronizeWithREX,
    rexId: transport.rexid ?? '',
    rexUrl: transport.rexurl ?? '',
    estType: transport.estCompanyType ?? '',
    logoUrl: transport.companyLogoURL ?? null,
  };
}
